import { gql } from "@apollo/client";

export const CREATE_FRANCHISE_REGION = gql`
  mutation createFranchiseRegion($data: CreateFranchiseRegionInput!) {
    createFranchiseRegion(data: $data) {
      id
    }
  }
`;

export const UPDATE_FRANCHISE_REGION = gql`
  mutation updateFranchiseRegion($data: UpdateFranchiseRegionInput!) {
    updateFranchiseRegion(data: $data) {
      id
    }
  }
`;

export default CREATE_FRANCHISE_REGION;
